import React from 'react';
import cl from "./EducationCase.module.css";
import case1 from "../../../../images/Шахматы.jpg";
import { Course } from '../../../../api/api'; // Импортируем из api.ts

interface EducationCaseProps {
    item: Course;
}

const EducationCase: React.FC<EducationCaseProps> = ({ item }) => {
    const pluralize = (n: number, [one, few, many]: [string, string, string]) => {
        const mod10 = n % 10;
        const mod100 = n % 100;
        if (mod100 >= 11 && mod100 <= 14) return many;
        if (mod10 === 1) return one;
        if (mod10 >= 2 && mod10 <= 4) return few;
        return many;
    };
    return (
        <div className={cl.eruditCard}>
            <div className={cl.eruditCard__trumb}>
                <img src={item.image ? (item.image.startsWith('data:') ? item.image : `data:image/jpeg;base64,${item.image}`) : case1} alt=""/>
            </div>
            <h3>
                {item.name}
            </h3>
            <div className={cl.eruditCard__content}>
                {item.description}
            </div>
            <div className={cl.eruditCard__row}>
                <div className={cl.eruditCard__price}>
                    {item.price} ₽ в месяц
                </div>
                <div className={cl.eruditCard__rowInfo}>
                    {item.duration > 0 && (
                        <div className={cl.eruditCard__price}>
                            {item.duration} нед.
                        </div>
                    )}
                    <div className={cl.eruditCard__price}>
                        {item.count} {pluralize(item.count, ['занятие', 'занятия', 'занятий'])}
                        {item.timeLesson > 0 && ` / ${item.timeLesson} мин.`}
                    </div>
                </div>

            </div>
            <a className={cl.eruditCard__btn} href="https://max.ru/u/f9LHodD0cOIs9p6PJRQtfZISoVAwHa37CvW1w92REzQ8aKo6Wf1dd4QY6UA">Записаться</a>
        </div>
    );
};

export default EducationCase;